import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FullScreenLoader from "./FullScreenLoader";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, loading } = useAuth();

  // Branded loader while auth is being refreshed (prevents flash of wrong dashboard)
  if (loading) return <FullScreenLoader />;

  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
